/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }

  pin(conversationID) {
    return axios.post(`${this.url}/${conversationID}/pin`);
  }

  unpin(conversationID) {
    return axios.post(`${this.url}/${conversationID}/unpin`);
  }
}

export default new ConversationApi();
